import * as angular from "angular";
import { MyPositionDirective } from "./MyPositionDirective";
import { PaginationControlDirective } from "./PaginationControlDirective";
import { PaginationDirective } from "./PaginationDirective";

export let playPagination = angular.module("play.pagination", ["ngResource"]);
playPagination.directive("rankingMyPosition", MyPositionDirective.instance());
playPagination.directive("rankingPaginationControl", PaginationControlDirective.instance());
playPagination.directive("rankingPlayPagination", PaginationDirective.instance());
